import device from '../util/device';
import debugUtil from '../util/debug';
import Config from '../config';
import VideoType from '../constants/video-type';

const Debug = debugUtil('resolve-video-type');

function allowDash(metadata) {

    // We have some decoding issues with simulcast in combination with DASH.js 2.6.0 and Mac OS (PIPELINE_ERROR_DECODE)
    if (device.isMacOS() && (metadata.simulcast || metadata.live)) {
        return false;
    }

    return device.supportsDash() && !((metadata.live || metadata.simulcast || metadata.timeshiftEnabled) && !device.supportsDashLive());
}

function allowFlash() {
    return Config.flashEngine && Config.flashEngine.load && device.isFlashCapable();
}

function resolveVideoAndTextUrls(videoType, videoUrls, textUrls) {

    switch(videoType) {
        case VideoType.HLS:
            return {
                videoUrl: videoUrls.hls,
                textUrl: textUrls.webvtt
            };
        case VideoType.DASH:
            return {
                videoUrl: videoUrls.dashhbbtv || videoUrls.dash264,
                textUrl: textUrls.webvtt
            };
        case VideoType.FLASHLS:
            return {
                videoUrl: videoUrls.hls,
                textUrl: textUrls.websrt
            };
        case VideoType.HDS:
            return {
                videoUrl: videoUrls.hds,
                textUrl: textUrls.websrt
            };
        default:
            return {};
    }
}

function resolveVideoType(videoUrls, textUrls, metadata, videoElement) {
    const dashVideoUrl = videoUrls.dashhbbtv || videoUrls.dash264;
    const hlsJsEnabled = !(textUrls.websrt && !textUrls.webvtt) && device.supportsHlsJs();

    if (dashVideoUrl && allowDash(metadata)) {
        return VideoType.DASH;
    } else if (videoUrls.hls && (device.supportsHls(videoElement) || hlsJsEnabled)) {
        return VideoType.HLS;
    } else if (videoUrls.hls && allowFlash()) {
        return VideoType.FLASHLS;
    } else if (videoUrls.hds && allowFlash()) {
        return VideoType.HDS;
    }

    return VideoType.UNKNOWN;
}

export default function (videoUrls, textUrls, metadata, videoElement) {
    const videoType = resolveVideoType(videoUrls, textUrls, metadata, videoElement);

    return Object.assign(
        { videoType },
        resolveVideoAndTextUrls(videoType, videoUrls, textUrls)
    );
}



// WEBPACK FOOTER //
// ./src/js/modules/resolve-streaming-config.js